import React from "react";
import "./styles.scss";

const ContactUsCard = ({ icon, cardLabel, cardValue, isLastItem }) => {
  return (
    <div
      className={`contact-us-card-container ${isLastItem && "border-bottom-0"}`}
    >
      <div className="item-container">
        <img src={icon} alt="card-icon" className="card-icon" />
        <div className="card-text-wrapper">
          <span className="card-label">{cardLabel}</span>
          <span className="card-value">{cardValue}</span>
        </div>
      </div>
    </div>
  );
};

export default ContactUsCard;
